import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import './styles/common.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const app = createApp(App)

app.use(createPinia())
app.use(router)
// app.use(ElementPlus) // 注册 Element Plus
app.use(ElementPlus,{
  locale: zhCn,
})

// 优化 ResizeObserver 错误处理
const debounceRAF = (fn) => {
  let animationFrameId = null;
  return (...args) => {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }
    animationFrameId = requestAnimationFrame(() => {
      fn(...args);
    });
  };
};

// 使用 MutationObserver 处理 DOM 变化
const observer = new MutationObserver(debounceRAF(() => {
  // 触发一次强制重排
  document.body.getBoundingClientRect();
}));

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// 自定义 ResizeObserver 错误处理
class CustomResizeObserver extends ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        if (!Array.isArray(entries)) return;
        callback(entries, observer);
      });
    });
  }
}

// 替换全局 ResizeObserver
window.ResizeObserver = CustomResizeObserver;

// 简化错误处理
app.config.errorHandler = (err) => {
  if (!err.message?.includes('ResizeObserver')) {
    console.error(err);
  }
};

app.mount('#app')
